import type { QuizQuestion } from '../api/endpoints.js';

/**
 * Does a conditional quiz question apply, given the answers so far?
 *
 * ONE implementation, deliberately: this predicate has to agree exactly with
 * the server's `appliesTo` (src/quiz/answers.ts), and it previously did not.
 * Two copies of it lived inline in the two quiz screens, both understanding
 * only the v1 singular `requires.value`, while migration 0028 seeded v3's
 * `requires.values` — two trigger answers. Neither copy could see the new
 * shape, so `discovery_method` was never rendered, never answered and never
 * sent, and every user who reported prior misuse was refused at submit.
 *
 * `values` and `value` are both honoured: the definition is data, and older
 * definitions still carry the singular form.
 */
export function quizQuestionApplies(
  question: QuizQuestion,
  answers: Record<string, string | string[]>,
): boolean {
  const gate = question.requires;
  if (gate === undefined) return true;

  const accepted = gate.values ?? (gate.value === undefined ? [] : [gate.value]);
  const trigger = answers[gate.key];
  if (typeof trigger === 'string') return accepted.includes(trigger);
  if (Array.isArray(trigger)) return trigger.some((entry) => accepted.includes(entry));
  return false;
}
